import TabBar, { TabBarProps } from "../../../shared/components/TabBar";
import Content from "../Content";
import MaterialCategoryGroups from "../MaterialCategoryGroups";
import MaterialExportHistory from "../MaterialExportHistory";
import MaterialImportHistory from "../MaterialImportHistory";
import MaterialQuantityTrackingTab from "../MaterialQuantityTrackingTab";

const MaterialListTabNavigations = () => {
    const tabs: TabBarProps[] = [
        {
            label: "Danh sách vật tư",
            labelEN: "material-list",
            content: <Content />,
        },
        {
            label: "Quản lý nhóm vật tư",
            labelEN: "material-category-group-management",
            content: <MaterialCategoryGroups />,
        },
        {
            label: "Phiếu nhập kho",
            labelEN: "material-import-history",
            content: <MaterialImportHistory />
        },
        {
            label: "Phiếu xuất kho",
            labelEN: "material-export-history",
            content: <MaterialExportHistory />,
        },
        {
            label: "Nhập xuất tồn",
            labelEN: "material-quantity-tracking",
            content: <MaterialQuantityTrackingTab />,
        },
    ];

    return <TabBar tabs={tabs} tabParamName="tab" defaultTab="material-list" />;
};

export default MaterialListTabNavigations;